import { ref } from 'vue'
import { useAuthStore } from '@/views/Authentication/store'
import { useDeviceStore } from '@/views/Devices/store'
import { useLocationsStore } from '@/views/Locations/store'

export function useDeviceLoader() {
  const authStore = useAuthStore()
  const deviceStore = useDeviceStore()
  const locationsStore = useLocationsStore()

  const loading = ref(false)
  const error = ref<Error | null>(null)

  /**
   * Carga devices según el rol del usuario:
   * - Admin: todos los devices
   * - Customer: devices filtrados por locations de su compañía
   */
  const loadDevicesByRole = async (): Promise<void> => {
    loading.value = true
    error.value = null

    try {
      const userRole = authStore.userProfile?.role
      const companyId = authStore.userProfile?.companyId

      // ADMIN: Cargar todos los devices
      if (userRole === 'admin') {
        console.log('[useDeviceLoader] Admin user - loading all devices')
        await deviceStore.getDevices()
        return
      }

      // CUSTOMER: Cargar devices filtrados
      if (userRole === 'user') {
        // Validar companyId
        if (!companyId) {
          throw new Error('Usuario customer sin companyId asignado. Contacte al administrador.')
        }

        console.log('[useDeviceLoader] Customer user - loading devices for company:', companyId)

        // 1. Cargar locations por companyId (se guardan en store)
        await locationsStore.getLocationsByCompanyId(companyId)

        // 2. Obtener locations del store state
        const locations = locationsStore.locations

        // 3. Validar que existan locations
        if (!locations || locations.length === 0) {
          console.warn('[useDeviceLoader] No locations found for company:', companyId)
          deviceStore.devices = []
          return
        }

        // 4. Extraer locationIds
        const locationIds = locations.map(loc => loc.id)
        console.log('[useDeviceLoader] Found', locationIds.length, 'locations')

        // 5. Cargar devices por locationIds
        await deviceStore.getDevicesByLocationIds(locationIds)
        return
      }

      // Rol desconocido
      throw new Error(`Rol de usuario desconocido: ${userRole}`)

    } catch (err) {
      const errorObj = err instanceof Error ? err : new Error('Error desconocido cargando devices')
      error.value = errorObj
      console.error('[useDeviceLoader] Error:', errorObj)
      throw errorObj // Re-throw para que las vistas manejen el error

    } finally {
      loading.value = false
    }
  }

  return {
    loading,
    error,
    loadDevicesByRole
  }
}
